import styles from './license-access-grid.module.scss';
import { useState } from 'react';
import { useTableConfigHook } from '../../requestUtils';
import { booleanHeader, CreateHeaders, dateHeader, HeaderSizeEnum, MenuItem, Select, textHeader } from '@frontend-workspace/react-shared-lib';
import { IOption } from '../../_models/option';
import { ILicenseAccess } from '../../_models/license-access';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface LicenseAccessGridProps {
  licenseAccess: ILicenseAccess[],
  products: IOption[],
  selectedproduct: number,
  onSelectProduct: (product: number) => void
}

export function LicenseAccessGrid(props: LicenseAccessGridProps) {
  const { t } = useTranslation();
  const [showUniqueByField, setShowUniqueByField] = useState<IOption | undefined>(undefined);
  const tableConfig = useTableConfigHook("licenseAccessGrid");

  const handleSelectedChange = (event: any) => props.onSelectProduct(event.target.value);
  const handleShowUniqueByFieldChange = (event: any) => setShowUniqueByField(event.target.value);

  return <>
    <div className="d-flex flex-row align-items-end flex-wrap">
      <div className="mb-3 mb-xxl-0 me-4">
        <Select
          displayEmpty
          value={props.selectedproduct || ''}
          onChange={handleSelectedChange}
          fullWidth
          sx={{ width: '300px' }}
          label="Velg produkt">
          {props.products?.map(p => (
            <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>
          ))}
        </Select>
      </div>
      <div className="mb-3 mb-xxl-0">
        <Select
          displayEmpty
          value={showUniqueByField}
          onChange={handleShowUniqueByFieldChange}
          fullWidth
          sx={{ width: '300px' }}
          label={t("licenseAccessGrid.mergeInFields")}>
          {/* Todo:: får feilmelding i console! */}
          {/* {props.products?.map(p => (
            <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>
          ))} */}
        </Select>
      </div>
    </div>
    <WebkuaTable
      headers={CreateHeaders([
        textHeader("userId", t("licenseAccessGrid.userID"), HeaderSizeEnum.MEDIUM),
        textHeader("firstName", t("standard.firstName"), HeaderSizeEnum.LARGE),
        textHeader("lastName", t("standard.lastName"), HeaderSizeEnum.LARGE),
        textHeader("userName", t("standard.username"), HeaderSizeEnum.EXTRA_LARGE),
        dateHeader("maintenanceExpirationDate", t("licenseAccessGrid.maintenanceExpiration")),
        textHeader("companyNumber", t("standard.companyNo"), HeaderSizeEnum.MEDIUM),
        textHeader("productName", t("standard.productName"), HeaderSizeEnum.EXTRA_LARGE),
        booleanHeader("isSlm", "SLM"),
        textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
        textHeader("personId", t("standard.personID"), HeaderSizeEnum.MEDIUM)
      ])}
      data={props.licenseAccess}
      tableConfig={tableConfig}
    />
  </>;
}

export default LicenseAccessGrid;